<template lang="pug">
  .progress-view-switch-container
    WtButton(
      @click.native="toggleOn('left')"
      :disabled="buttonToggledOn==='left'"
      :size="size"
    ) {{leftButtonText}}
    WtButton(
      @click.native="toggleOn('right')"
      :disabled="buttonToggledOn==='right'"
      :size="size"
    ) {{rightButtonText}}
</template>

<script>
import WtButton from "@@/WtButton/WtButton";

export default {
  name: "WtButtonToggle",
  components: {
    WtButton
  },
  props: {
    activeToggle: {
      type: String,
      default: "left"
    },
    leftButtonText: {
      type: String,
      default: "left"
    },
    rightButtonText: {
      type: String,
      default: "right"
    },
    size: {
      type: String,
      default: "normal"
    }
  },
  computed: {
    buttonToggledOn() {
      return this.activeToggle;
    }
  },
  methods: {
    toggleOn(toggleDirection) {
      this.$emit("toggleOn", toggleDirection);
    }
  }
};
</script>

<style lang="sass" scoped>
.progress-view-switch-container
  background-color: $grey-light
  width: 244px
  padding: 2px
  box-sizing: border-box
  border-radius: 12px
  max-width: 100%
  margin: 10px 0

  button
    width: 120px
    background-color: transparent
    color: $grey
    font-weight: $weight-bold
    max-width: 50%

  button:disabled
    background-color: $white
    color: $black
    opacity: 1 !important
</style>
